import { Injectable } from '@angular/core';
import {
  IBulkDocumentsUpload,
  IDocumentsUpload,
  IDocumentsUploadResponse,
} from '@inshuwa-client/models';
import { HttpClient } from '@angular/common/http';
import { baseUrl } from '../configs/baseUrl';

@Injectable({
  providedIn: 'root',
})
export class FilesService {
  constructor(private http: HttpClient) {}

  uploadDocument(payload: IDocumentsUpload) {
    const uploadData = new FormData();
    uploadData.append('BucketName', payload.bucketName);
    let file = payload.file;

    if (payload.addTimeStamp) {
      const date = new Date();
      const timeStamp = date.getTime();
      const fileName =  file.name.split('.');
      const newFileName = `${fileName[0]}-${timeStamp}.${fileName[fileName.length - 1]}`;
      file = new File([file], newFileName, { type: file.type });
    }

    uploadData.append('File', file);

    if (payload.directory) {
      uploadData.append('directory', payload.directory);
    }
    // Through the Inshuwa API: it holds the storage API key and returns the same response shape.
    return this.http.post<IDocumentsUploadResponse>(
      `${baseUrl()}/files`,
      uploadData,
    );
  }

  bulkUploadDocuments(payload: IBulkDocumentsUpload) {
    const uploadData = new FormData();

    uploadData.append('BucketName', payload.bucketName);

    payload.files.forEach((file) => {
      uploadData.append('Files', file);
    });

    return this.http.post<IDocumentsUploadResponse[]>(
      `${baseUrl()}/files/bulk`,
      uploadData,
    );
  }
}
